import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ ...params }) => {
  return dponetAPI.get('/backoffice/governance_projects/list', { params })
}

const getSettings = async ({ governanceProjectId }) => {
  return dponetAPI.get(
    `/backoffice/governance_projects/${governanceProjectId}/governance_project_settings`,
  )
}

const createSetting = async ({ governanceProjectId, ...data }) => {
  return dponetAPI.post(
    `/backoffice/governance_projects/${governanceProjectId}/governance_project_settings`,
    data,
  )
}

const updateSetting = async ({ governanceProjectId, settingId, ...data }) => {
  return dponetAPI.patch(
    `/backoffice/governance_projects/${governanceProjectId}/governance_project_settings/${settingId}`,
    data,
  )
}

const daiDisputeAnalysis = async ({ governanceProjectId }) => {
  return dponetAPI.post(
    `/backoffice/governance_projects/${governanceProjectId}/dai_dispute_analysis`,
  )
}

const governanceProjects = {
  get,
  getSettings,
  createSetting,
  updateSetting,
  daiDisputeAnalysis,
}

export default governanceProjects
